import { StoreModel } from '../store.model';
import { NewsItem } from '../../types/domain/news-item.types';

export const newsItemContentSelector = (state: StoreModel): NewsItem | undefined => state.newsItem.content;

export const isLoadingSelector = (state: StoreModel): boolean => state.newsItem.isLoading;
